import { Head } from "@inertiajs/react"
import { AppLayout } from "../../components/layout/AppLayout"
import { UserForm } from "../../features/users/UserForm"

type NewUserPageProps = {
  user: {
    email: string
    password: string
    password_confirmation: string
  }
  errors?: Record<string, string[]>
}

export default function NewUserPage({ user, errors }: NewUserPageProps) {
  return (
    <>
      <Head title="Novo Usuário" />
      <AppLayout>
        <div className="mx-auto w-full max-w-6xl p-8">
          <div className="mb-6">
            <h1 className="text-3xl font-bold text-white">Novo Usuário</h1>
            <p className="text-slate-400">Crie um novo usuário para acesso ao portal.</p>
          </div>
          <UserForm initialValues={user} submitUrl="/usuarios" submitLabel="Criar usuário" method="post" errors={errors} />
        </div>
      </AppLayout>
    </>
  )
}
